export const downloadURL = "https://api.afga.elmis.af/Documents"
// export const downloadURL = "http://localhost:8000/Documents"
